import {TextField} from '@hconnect/common/components'
import {ControlledFormField} from '@hconnect/common/types'
import {Stack} from '@mui/material'
import React from 'react'
import {FieldValues, Path, useController, useWatch} from 'react-hook-form'

import {useWidgetTranslation} from '../../hooks'
import {YesNoFormValue} from '../../types'

import {YesNoField} from './YesNoField'

type YesNoWithCommentFieldProps<TField extends FieldValues> = ControlledFormField<TField>

export const YesNoWithCommentField = <TField extends FieldValues>({
  label,
  name,
  control,
  disabled,
  readOnly
}: YesNoWithCommentFieldProps<TField>) => {
  const {t} = useWidgetTranslation()
  const value = useWatch({control, name: `${name}.value` as Path<TField>})

  const commentController = useController({
    control,
    name: `${name}.comment` as Path<TField>
  })

  const handleValueChange = (_e: React.ChangeEvent<HTMLInputElement>, newValue: YesNoFormValue) => {
    if (newValue === YesNoFormValue.YES && commentController.field.value) {
      commentController.field.onChange(undefined)
    }
  }

  return (
    <Stack spacing={1}>
      <YesNoField
        label={label}
        name={`${name}.value` as Path<TField>}
        control={control}
        disabled={disabled}
        readOnly={readOnly}
        onChange={handleValueChange}
      />
      {value === YesNoFormValue.NO && (
        <TextField
          name={`${name}.comment` as Path<TField>}
          label={t('label.comment')}
          control={control}
          disabled={disabled}
          readOnly={readOnly}
        />
      )}
    </Stack>
  )
}
